<template>
  <v-autocomplete
    v-model="set"
    :items="sets"
    label="Devotional Set"
    @input="onInput"
  />
</template>

<script>
export default {
  name: 'DevotionalSetSelect',
  data: () => ({
    set: null,
    sets: []
  }),
  props: {
    value: Number,
    excludeFixed: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function () {
      this.set = this.value
    }
  },
  mounted: function () {
    var _this = this
    this.axios.get('/devotionals/sets')
      .then(function (res) {
        for (var i in res.data) {
          var v = res.data[i]
          if (!_this.excludeFixed ||
              (_this.excludeFixed && !v.isFixed)) {
            _this.sets.push({ text: v.title, value: v.id })
          }
        }
      })
      .catch(this.$root.apiErrorHandler())
  },
  methods: {
    // Propagate our selection so it works with a parent v-model
    onInput: function (ev) {
      this.$emit('input', this.set)
    }
  }
}
</script>
